import { memo } from 'react'

/**
 * Figma Label Component — 3 варианта
 *
 * Props:
 * - type: "default" | "dark" | "contrast" (default: "default")
 * - children: текст лейбла
 * - className: дополнительные классы
 *
 * Размеры из Figma:
 * - Размер: 74×38px (может растягиваться по контенту)
 * - Border radius: 999px (pill)
 * - Font: SF Pro Display Medium 510, 14px
 * - Padding: 10px 12px
 */

function Label({
  type = 'default',
  children,
  className = '',
  ...props
}) {
  const baseStyles = `
    inline-flex items-center justify-center
    h-[38px] px-3
    rounded-[999px]
    font-[510] text-[14px] leading-[16px] tracking-[-0.01em]
    whitespace-nowrap
  `

  const variantStyles = {
    default: 'bg-[var(--figma-surface-10)] border border-[var(--figma-border-20)] text-[var(--figma-text)]',
    dark: 'bg-[rgba(0,0,0,0.30)] text-[var(--figma-text)]',
    contrast: 'bg-[var(--figma-surface-10)] text-[var(--figma-text)] backdrop-blur-[4px]',
  }

  return (
    <span
      className={`${baseStyles} ${variantStyles[type]} ${className}`}
      {...props}
    >
      {children}
    </span>
  )
}

export default memo(Label)
